<template>
    <Dialog v-model:open="opened">
        <DialogTrigger class="w-full">
            <slot />
        </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>{{
                    $t("integrations.icloud_calendar.modal.title")
                }}</DialogTitle>
            </DialogHeader>
            <div class="sm:flex sm:items-start">
                <div class="mt-3 w-full text-center sm:mt-0 sm:text-left">
                    <h3
                        id="modal-title"
                        class="text-lg font-medium leading-6 text-iron-900"
                    ></h3>
                    <div class="mt-2">
                        <div class="mt-4">
                            <label
                                for="icloud-email"
                                class="block text-sm font-medium text-iron-700"
                                >{{
                                    $t(
                                        "integrations.icloud_calendar.modal.icloud_email_label",
                                    )
                                }}</label
                            >
                            <div class="mt-1 w-full">
                                <input
                                    v-model="iCloudEmail"
                                    type="email"
                                    data-cy="new-icloud-email"
                                    name="icloud-email"
                                    class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                                    :placeholder="
                                        $t(
                                            'integrations.icloud_calendar.modal.icloud_email_placeholder',
                                        )
                                    "
                                />
                            </div>
                        </div>
                        <div class="mt-4">
                            <label
                                for="app-specific-password"
                                class="block text-sm font-medium text-iron-700"
                                >{{
                                    $t(
                                        "integrations.icloud_calendar.modal.app_specific_password_label",
                                    )
                                }}</label
                            >
                            <div class="mt-1 w-full">
                                <input
                                    v-model="appSpecificPassword"
                                    type="text"
                                    data-cy="new-app-specific-password"
                                    name="app-specific-password"
                                    class="block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                                    :placeholder="
                                        $t(
                                            'integrations.icloud_calendar.modal.app_specific_password_placeholder',
                                        )
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="closeModal"
                >
                    {{ $t("cancel") }}
                </button>

                <ZButton
                    v-if="!iCloudIntegration"
                    class="ml-4"
                    type="button"
                    @click="createAppleCalendarIntegration"
                    >{{
                        $t("integrations.icloud_calendar.add_integration")
                    }}</ZButton
                >
                <ZButton
                    v-else
                    class="ml-4"
                    type="button"
                    @click="createAppleCalendarIntegration"
                    >{{
                        $t("integrations.icloud_calendar.update_integration")
                    }}</ZButton
                >
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import ZButton from "./../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";

import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import route from "ziggy-js";

const opened = ref(false);

const iCloudEmail = ref("" as string);
const appSpecificPassword = ref("" as string);

const props = defineProps<{
    preserveState?: boolean;
    iCloudIntegration?: any;
}>();

const createAppleCalendarIntegration = function () {
    if (props.iCloudIntegration) {
        router.put(
            route(
                "app.i-cloud-calendar-integrations.update",
                props.iCloudIntegration.id,
            ),
            {
                iCloudEmail: iCloudEmail.value,
                appSpecificPassword: appSpecificPassword.value,
            },
            {
                preserveState: props.preserveState ?? false,
                onFinish: () => {
                    closeModal();
                },
            },
        );

        return;
    }

    router.post(
        "/icloud-calendar-integrations",
        {
            iCloudEmail: iCloudEmail.value,
            appSpecificPassword: appSpecificPassword.value,
        },
        {
            preserveState: props.preserveState ?? false,
            onFinish: () => {
                closeModal();
            },
        },
    );
};

const closeModal = () => {
    opened.value = false;
};
</script>

<style></style>
